import React from 'react';
import { connect, useSelector } from 'react-redux';
import HorizontalCard from 'component/common/HorizontalCard/HorizontalCard';
import VerticalCard from 'component/common/VerticalCard/VerticalCard';
import { mapDispatchToProps } from 'component/common/ActivityPOICard/ActivitiyPOICard.selectors';
import { ActivityPOICardProps } from 'component/common/ActivityPOICard/ActivityPOICard.types';
import { StringFormatter } from '@agoda/react-handyman';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { selectScreenSize } from 'store/slice/screen';
import { PoiCardDisplayData } from 'component/common/ActivityPOICard/PoiListItem';

const removeParams = (url: string) => {
    if (!url) return url;
    const jpgIndex = url.indexOf('.jpg');
    if (jpgIndex === -1) {
        // Return the original string if no .jpg is found
        return url;
    }
    // Return the substring up to and including .jpg
    return url.substring(0, jpgIndex + 4);
};

export const ActivityPOICardComponent: React.FC<ActivityPOICardProps> = (props) => {
    const { poi, index, isLoading } = props;
    const screenSize = useSelector(selectScreenSize);
    const cms = useSelector(selectCmsFromBootstrap);

    const onSeen = (inView: boolean) => {
        if (!isLoading && poi && inView) {
            props.onSeen();
        }
    };

    const displayData = React.useMemo<PoiCardDisplayData>(() => {
        const activities = poi?.activities || [];
        return {
            activities,
            title: poi?.name,
            subTitle: StringFormatter.format(cms[107193], index + 1),
            // for removeParams we are doing temporary fix for image url https://jira.agodadev.io/browse/ACT-4549
            image: (poi && removeParams(poi.imageUrl)) || activities?.[0]?.image?.url || '',
            imageAlt: poi?.name, // This is a placeholder, the actual value should be the alt text of the image
        };
    }, [poi, index, cms]);

    if (screenSize.desktop) {
        return <HorizontalCard index={index} data={displayData} isLoading={isLoading} onHover={props.onHover} onSeen={onSeen} />;
    }

    return <VerticalCard index={index} data={displayData} isLoading={isLoading} onHover={props.onHover} onSeen={onSeen} />;
};

ActivityPOICardComponent.displayName = 'ActivityPOICard';
export default connect(undefined, mapDispatchToProps)(ActivityPOICardComponent);
